<template>
  <v-dialog
    persistent
    :value="dialog"
    @input="dialog = $event"
    width="640px"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="button" :activator="{ on, attrs }" />
    </template>
    <div class="white pa-4 content">
      <ACLEditor
        dense
        :document="analysis"
        :on-prepared-analysis="onPreparedAnalysis"
        :show-buttons="false"
        ref="aclEditor"
        @change="change"
        @saved="onACLEditorSaved"
        @cancel="onACLEditorCancelled"
        @savePreparedAnalysis="() => $emit('savePreparedAnalysis')"
      />
    </div>
    <div class="button-bar d-flex justify-end pt-5 pb-5 pr-4 white">
      <v-btn
        text
        small
        color="primary"
        class="mx-2"
        @click.stop="cancel"
      >
        {{ $t('actions.cancel') }}
      </v-btn>
      <v-btn
        small
        elevation="0"
        color="primary"
        class="mx-2"
        @click.stop="save"
        :disabled="!saveButtonEnabled"
      >
        {{ $t('actions.save') }}
        <v-progress-circular
          v-if="inProgress"
          indeterminate
          :size="18"
          :width="3"
          class="ml-2"
        />
      </v-btn>
    </div>
  </v-dialog>
</template>
<script>
import ACLEditor from './ACLEditor';

export default {
  name: 'SendAnalysis',
  components: {
    ACLEditor,
  },
  data: () => ({
    dialog: false,
    saveButtonEnabled: false,
    inProgress: false,
  }),
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    analysis: {
      type: Object,
      required: true,
    },
    onPreparedAnalysis: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit('cancel');
    },
    onACLEditorSaved() {
      this.close();
      this.inProgress = false;
    },
    onACLEditorCancelled() {
      this.inProgress = false;
    },
    change() {
      this.saveButtonEnabled = true;
    },
    save() {
      this.inProgress = true;
      this.$refs.aclEditor.startSaveProcess();
    },
    reset() {
      this.inProgress = false;
      this.saveButtonEnabled = false;
    },
    close() {
      this.dialog = false;
      this.reset();
      this.$emit('close');
    },
  },
  watch: {
    value(newValue) {
      this.dialog = newValue;
      if (this.$refs.aclEditor) {
        this.$refs.aclEditor.reset();
      }
    },
  },
};
</script>
<style scoped>
.content {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
.button-bar {
  border-top: 1px solid #ced2ee;
  border-color: #ced2ee;
  box-shadow: 0px -1px 12px rgb(0 0 0 / 7%);
}
</style>
